<template>
  <div>
    <h3 class="title dw_green--text font-weight-light">
      <v-icon color="dw_green" class="mr-2 mb-1" v-text="mdiCrownOutline" />
      Existing Plays
    </h3>
    <v-row no-gutters>
      <v-col cols="11">
        <v-text-field
          v-model="search"
          @change="searchExisting"
          @click:clear="search = ''; searchExisting()"
          label="Search Plays"
          :append-icon="mdiMagnify"
          color="dw_green"
          hide-details
          clearable
        ></v-text-field>
      </v-col>
    </v-row>
    <v-card width="33vw" max-height="50vh" class="pa-2 my-2 existing-list">
      <p v-for="play of plays" :key="play" class="grey--text caption mb-1">{{ play }}</p>
    </v-card>
  </div>
</template>

<script>
import { mdiCrownOutline, mdiMagnify } from '@mdi/js';
import { mapGetters } from 'vuex';

export default {
  name: 'playList',
  data() {
    return {
      mdiCrownOutline,
      mdiMagnify,
      search: '',
      plays: []
    }
  },
  computed: {
    ...mapGetters([
      'playOptions'
    ])
  },
  mounted() {
    this.plays = this.playOptions.map((play) => play.name);
  },
  methods: {
    searchExisting() {
      this.plays = this.playOptions.map((play) => play.name);
      if (this.search !== '') {
        this.plays = this.plays.filter((play) => {
          const s = this.search.toLowerCase();
          return play.toLowerCase().includes(s);
        });
      }
    }
  }
};
</script>

<style scoped>
.existing-list {
  height: inherit;
  overflow-y: scroll;
}
</style>
